import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Ticker } from '@pixi/ticker';

import { Shared } from '../App';
import { Shine } from './Shine';

export class Diamond extends Container
{
    public shine: Shine;
    public sprite: Sprite;
    public wobble: boolean;

    constructor(size = 'large', baseScale = 1, wobble = false)
    {
        super();

        this.wobble = wobble;

        this.sprite = new Sprite(Shared.assets.getTexture(`diamond-${size}`));
        this.sprite.anchor.set(0.5);
        this.addChild(this.sprite);

        const isLarge = size === 'large';

        this.scale.set(baseScale);
        this.shine = new Shine(isLarge ? 2 : 0.5);
        this.sprite.addChild(this.shine);

        this.shine.x = (isLarge ? 50 : 10);
        this.shine.y = -(isLarge ? 50 : 10);
    }

    public updateTransform(): void
    {
        super.updateTransform();
        this.sprite.rotation = this.wobble ? Math.sin(Ticker.system.lastTime * 0.005) * 0.1 : 0;
    }
}
